import React from "react";
import {
  Container,
  Row,
  Card,
  CardImg,
  List,
  ListInlineItem,
} from "reactstrap";
import cn from "classnames";

import * as style from "./portada.module.scss";
import * as icon from "./icon.module.scss";
import logo from "images/logojose02.svg";
import linkedin from "./linkedin.svg";
import email from "./email.svg";
import twitter from "./twitter.svg";

const twitterLink = "https://twitter.com/Jmartinarocha?lang=es";
const linkedinLink = "https://www.linkedin.com/in/josemartinarocha";
const mailTo = "mailto:josemartinarocha@gmail.com";

const Portada = () => {
  return (
    <>
      <section id="main">
        <Container fluid className={cn(style.portada, "no-padding")}>
          <Row className="justify-content-md-center">
            <div className={cn(style.portada__logo_container, "col-1")}>
              <Card className={style.portada__logo}>
                <CardImg top src={logo} alt="Jose Martin Arocha" />
              </Card>
            </div>
          </Row>
          <Row className="text-center mt-5">
            <h1 className={cn(style.portada__name)}>
              #JoséMartínArocha
              <span className={cn(style.portada__charge)}>.PM</span>
            </h1>
          </Row>
          <Row className="justify-content-md-center text-center mt-5">
            <List type="inline" className={cn(icon.header_contact_list)}>
              <ListInlineItem className={cn("col-1")}>
                <a className={cn(style.portada__hover)} href={mailTo}>
                  <img
                    className={cn(style.portada__img)}
                    src={email}
                    alt="MailTo: Jose Martin Arocha"
                  />
                </a>
              </ListInlineItem>
              <ListInlineItem className={cn("col-1")}>
                <a className={cn(style.portada__hover)} href={linkedinLink}>
                  <img
                    className={cn(style.portada__img)}
                    src={linkedin}
                    alt="Linkedin: Jose Martin Arocha"
                  />
                </a>
              </ListInlineItem>
              <ListInlineItem className={cn("col-1")}>
                <a className={cn(style.portada__hover)} href={twitterLink}>
                  <img
                    className={cn(style.portada__img)}
                    src={twitter}
                    alt="Twitter: Jose Martin Arocha"
                  />
                </a>
              </ListInlineItem>
            </List>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Portada;
